export default __webpack_public_path__ + "static/media/varsovieMinia.79ebdfbe.png";